import type { ArtistContact } from '~/modules/artist-roster/lib/types';

import { ContactCard } from './ContactCard';

interface ContactCardsProps {
  contacts: ArtistContact[] | undefined;
}

export function ContactCards({ contacts }: ContactCardsProps) {
  const isMultiple = (contacts?.length ?? 0) > 1;

  if (!contacts?.length) {
    return null;
  }

  return (
    <div className={isMultiple ? 'grid grid-cols-2 gap-md' : 'inline-block'}>
      {contacts.map((contact) => (
        <ContactCard
          key={`${contact.firstName}-${contact.lastName}`}
          contact={contact}
        />
      ))}
    </div>
  );
}

ContactCards.displayName = 'ContactCards';
